import React from "react";
import { useState } from "react";

import { Typography, Button } from "@mui/material";

const StepOneForm = (props) => {
  //eslint-disable-next-line
  const [completed, setCompleted] = useState(true);

  return (
    <React.Fragment>
      <Typography variant="h4" sx={{ mt: "3rem", mb: 1, fontWeight: "bold" }}>
        You've been invited to be a mentor.
      </Typography>
      <Typography variant="body1">
        The 100 Club is a private mastermind community for founders in
        Singapore. We would like to invite you to join us as a mentor in our
        community.
      </Typography>
      <Typography variant="body1" sx={{ mt: "1rem", fontWeight: "bold" }}>
        What do you do as a mentor?
      </Typography>
      <Typography variant="body1">
        Upon registration, your profile will be added to our mentor directory,
        and members will be able to reach out to you to schedule chats and seek
        advice.
      </Typography>
      <Typography variant="body1" sx={{ mt: "1rem", fontStyle: "italic" }}>
        You will also be added to our private telegram community housing our
        members.
      </Typography>
      <Button
        color="primary"
        variant="contained"
        fullWidth
        type="submit"
        sx={{ mt: "1rem" }}
        onClick={props.handleNext}
      >
        I'm ready
      </Button>
    </React.Fragment>
  );
};

export default StepOneForm;
